module.exports = __webpack_public_path__ + "static/img/qrcode.86c7a1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcode.png
// module id = jWhC
// module chunks = 64